// Module
var code = `<form
      name="serverForm"
      sf-schema="\$ctrl.schema"
      sf-form="\$ctrl.form"
      sf-model="\$ctrl.model"
      sf-options="\$ctrl.options"
      ng-submit="\$ctrl.onSubmit({ form: serverForm, model: \$ctrl.model})"
      class="form">
</form>
`;
// Exports
module.exports = code;